import React from "react"
import { CreditCard } from "@medusajs/icons"

import Ideal from "@modules/common/icons/ideal"
import Bancontact from "@modules/common/icons/bancontact"
import PaypalIcon from "@modules/common/icons/paypal"

/* Map of payment provider_id to their title and icon. Add in any payment providers you want to use. */
export const paymentInfoMap: Record<
  string,
  { title: string; icon: React.JSX.Element }
> = {
  pp_stripe_stripe: {
    title: "Credit / Debit Card",
    icon: <CreditCard />,
  },
  pp_ideal_stripe: {
    title: "iDEAL",
    icon: <Ideal />,
  },
  pp_bancontact_stripe: {
    title: "Bancontact",
    icon: <Bancontact />,
  },
  pp_system_default: {
    title: "Cheque / Money Order",
    icon: <CreditCard />,
  },
  pp_paypal_paypal: {
    title: "PayPal",
    icon: <PaypalIcon />,
  },
  // Add more payment providers here
}

// Matches any Stripe-based provider (card, iDEAL, Bancontact, Klarna, etc.)
export const isStripeLike = (providerId?: string) => {
  return providerId?.endsWith("_stripe") || providerId?.startsWith("pp_medusa-")
}

export const isPaypal = (providerId?: string) => {
  return providerId?.startsWith("pp_paypal")
}

/**
 * PayPal's public client ID. Empty when the storefront isn't configured for PayPal.
 *
 * Read it from here rather than reaching for process.env directly — it was
 * duplicated across three components, which is how one of them ended up out of
 * step with the others.
 */
export const PAYPAL_CLIENT_ID = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID

/**
 * Whether a PayPalScriptProvider can actually be mounted.
 *
 * Every component that calls `usePayPalScriptReducer()` MUST return early when
 * this is false. That hook throws ("usePayPalScriptReducer must be used within a
 * PayPalScriptProvider") if no provider is present, and an unhandled throw in a
 * client component takes down the whole route via its error boundary — an unset
 * key used to blank the entire product page. See issue #102.
 */
export const isPaypalConfigured = () => Boolean(PAYPAL_CLIENT_ID)
export const isManual = (providerId?: string) => {
  return providerId?.startsWith("pp_system_default")
}

/**
 * Google reCAPTCHA's public site key. Empty when the storefront isn't
 * configured for it.
 *
 * Same failure mode as PAYPAL_CLIENT_ID above: react-google-recaptcha throws
 * when this is unset, and an unhandled throw in a client component takes
 * down the whole route via its error boundary.
 */
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
export const isRecaptchaConfigured = () => Boolean(RECAPTCHA_SITE_KEY)
